<template>
  <div class="w-100 vh-100 p-5">
    <div class="close-btn text-end">
      <span @click="close()" class="cursor-pointer"> <close-svg /> </span>
    </div>

    <div
      class="
        container
        my-5
        date-target-container
        d-flex
        justify-content-center
        flex-column
      "
    >
      <div class="d-flex">
        <div class="mx-4 calender-container">
          <h5 class="text-capitalize ps-4 pt-4 m-0">survey end date</h5>

          <v-date-picker v-model="date" :min-date="new Date()" />
        </div>

        <div
          class="
            target-container
            d-flex
            flex-column
            justify-content-between
            mx-4
          "
        >
          <div>
            <h5 class="text-capitalize">Target No. Of Respondents</h5>
            <input
              class="px-5 py-2 mt-3 targetInput"
              type="number"
              :placeholder="inputPlaceholder"
              @focus="placeholder = ''"
              v-model="targetValue"
            />
          </div>
          <h5 class="target-description">
            Please enter a target number of responses (this is only for your
            tracking purposes and does not have an automatic effect the survey
            status)
          </h5>
        </div>
      </div>

      <div class="m-4 d-flex align-items-center">
        <input type="checkbox" id="checkbox" v-model="changeCode" />
        <label for="checkbox" class="mx-2"> change survey Code</label>
      </div>
    </div>

    <div class="text-center mt-5">
      <button class="border-0 btn-start" @click="handlePublish()">
        <a class="text-capitalize py-3 px-5 d-block">let's go!</a>
      </button>

      <transition name="fade">
        <small
          class="text-danger text-capitalize px-4 d-block mt-3"
          v-if="validationMsg"
        >
          Date and Target are required
        </small>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "PublishSetting",
  props: [],
  data() {
    return {
      date: "",
      inputPlaceholder: "Target",
      targetValue: "",
      validationMsg: false,
      changeCode: false,
    };
  },

  methods: {
    close() {
      this.$emit("close-popup");
    },
    handlePublish() {
      if (this.date === "" || this.targetValue === "") {
        this.validationMsg = true;
      } else {
        this.$emit("publishEvent");
        try {
          this.$store.dispatch("surveyJourney/setPublishSurvey", {
            endDate: this.date.toISOString(),
            targetRespondentsNo: this.targetValue,
            keepSameCode: !this.changeCode,
          });
        } catch (error) {
          this.$store.dispatch("dialog/showErrorDialog", {
            error: error,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.date-target-container {
  height: calc(100vh - 21.875rem);
}

.target-container {
  background-color: $color-grey-100;
  border: $border-white-1;
  border-radius: $radius-20;
  padding: 1.5rem;
  width: 600px;
  min-height: 600px;
  height: min-content;
}

.target-description {
  text-align: left;
  color: $color-grey-40;
  padding-left: 1.1rem;
}

.targetInput {
  max-width: 100%;
  background-color: $color-grey-70;
  border-radius: $radius-75;
  font-weight: $font-weight-light;
  font-size: $font-size-80;
  line-height: $line-height-127;
  letter-spacing: 0;
  color: $color-white;
  border: unset;
  outline: unset;
}

.target-container p,
.calender-container p {
  font-weight: $font-weight-semiBold;
}

.calender-container {
  border: $border-white-1;
  border-radius: $radius-20;
  background-color: $color-grey-100;
}
</style>
